var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -0.25,
    width: 31,
    height: 23.25,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0 -0.00459318) scale(0.000984252 0.00131234)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 1016,
    height: 769,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanish);
export default __webpack_public_path__ + "static/media/danish.0b0a502a1e1cef74e1d5e73b20ca2bb2.svg";
export { ForwardRef as ReactComponent };